setTimeout(function() {
    jq('.cc-nb-main-container').fadeOut('slow');
}, 20000);